import React from "react"
import { Link } from "react-router-dom"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Icon from "semantic-ui-react/dist/es/elements/Icon/Icon"
const NavUpLinkBar = ({ path, label }) => (
  <Grid>
    <Grid.Row
      style={{
        borderBottom: "1px solid #e4e4e4",
        padding: "1em",
        paddingBottom: "1em"
      }}
    >
      <Grid.Column style={{ padding: "0" }}>
        <Link style={{ color: "#00b8ee" }} to={path}>
          <Icon name="left chevron" />
          {label}
        </Link>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

export default NavUpLinkBar
